import type {LegacyId, InputMapsInfo} from "#material-maps-exporter/core/types"
import type {MapsExporterDataSource} from "#material-maps-exporter/core/data-source"
import {gatherMaterialData, getAveragePhysicalSize} from "#material-maps-exporter/core/gather-material-data"
import {getImageMapInfos} from "#material-maps-exporter/core/image-processing-graph"

export async function gatherMaterialDataForPconExport(
    dataSource: MapsExporterDataSource,
    materialId: {legacyId: LegacyId} | {id: string},
): Promise<{
    mapsInfo: InputMapsInfo
    commonWidthCm: number
    commonHeightCm: number
}> {
    const {mapsInfo} = await gatherMaterialData(dataSource, materialId)
    const imageMapsInfo = getImageMapInfos(mapsInfo)

    const {width, height} = getAveragePhysicalSize(imageMapsInfo)

    return {
        mapsInfo,
        commonWidthCm: width,
        commonHeightCm: height,
    }
}
